'use client';

import React from 'react';
import { Shield, Coins, TrendingUp, AlertTriangle } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';

interface SummaryCard {
  id: string;
  label: string;
  IconComponent: React.ElementType;
  color: string;
  source: string;
}

const summaryCards: SummaryCard[] = [
  {
    id: 'vs-total-staked',
    label: 'Total Staked RTWO',
    IconComponent: Coins,
    color: 'text-muted-foreground bg-muted',
    source: 'Real Validator Node',
  },
  {
    id: 'vs-active-validators',
    label: 'Active Validators',
    IconComponent: Shield,
    color: 'text-muted-foreground bg-muted',
    source: 'Real Validator Node',
  },
  {
    id: 'vs-avg-apr',
    label: 'Average APR',
    IconComponent: TrendingUp,
    color: 'text-muted-foreground bg-muted',
    source: 'Real Validator Node',
  },
  {
    id: 'vs-slash-events',
    label: 'Slashing Events (30d)',
    IconComponent: AlertTriangle,
    color: 'text-muted-foreground bg-muted',
    source: 'Real Validator Node',
  },
];

export default function ValidatorSummary() {
  return (
    <div data-component-id="src/app/validator-staking-management/components/ValidatorSummary.tsx:48:4" data-component-path="src/app/validator-staking-management/components/ValidatorSummary.tsx" data-component-line="48" data-component-end-line="73" data-component-file="ValidatorSummary.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20md%3Agrid-cols-4%20gap-4%22%7D" className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {summaryCards.map((card) => {
        const Icon = card.IconComponent;
        return (
          <div data-component-id="src/app/validator-staking-management/components/ValidatorSummary.tsx:52:10" data-component-path="src/app/validator-staking-management/components/ValidatorSummary.tsx" data-component-line="52" data-component-end-line="70" data-component-file="ValidatorSummary.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20border%20border-border%20rounded-xl%20p-4%20flex%20items-start%20gap-3%22%7D"
            key={card.id}
            className="bg-card border border-border rounded-xl p-4 flex items-start gap-3"
          >
            <div data-component-id="src/app/validator-staking-management/components/ValidatorSummary.tsx:56:12" data-component-path="src/app/validator-staking-management/components/ValidatorSummary.tsx" data-component-line="56" data-component-end-line="60" data-component-file="ValidatorSummary.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${card.color}`}
            >
              <Icon data-component-id="src/app/validator-staking-management/components/ValidatorSummary.tsx:59:14" data-component-path="src/app/validator-staking-management/components/ValidatorSummary.tsx" data-component-line="59" data-component-end-line="59" data-component-file="ValidatorSummary.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" size={18} />
            </div>
            <div data-component-id="src/app/validator-staking-management/components/ValidatorSummary.tsx:61:12" data-component-path="src/app/validator-staking-management/components/ValidatorSummary.tsx" data-component-line="61" data-component-end-line="69" data-component-file="ValidatorSummary.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
              <p data-component-id="src/app/validator-staking-management/components/ValidatorSummary.tsx:62:14" data-component-path="src/app/validator-staking-management/components/ValidatorSummary.tsx" data-component-line="62" data-component-end-line="64" data-component-file="ValidatorSummary.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-2xs%20text-muted-foreground%20uppercase%20tracking-wide%20font-medium%22%7D" className="text-2xs text-muted-foreground uppercase tracking-wide font-medium">
                {card.label}
              </p>
              <p data-component-id="src/app/validator-staking-management/components/ValidatorSummary.tsx:65:14" data-component-path="src/app/validator-staking-management/components/ValidatorSummary.tsx" data-component-line="65" data-component-end-line="67" data-component-file="ValidatorSummary.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-lg%20font-bold%20tabular-nums%20text-muted-foreground%20italic%22%2C%22textContent%22%3A%22Waiting%20for%20Real%20Data%22%7D" className="text-lg font-bold tabular-nums text-muted-foreground italic">
                Waiting for Real Data
              </p>
              <p data-component-id="src/app/validator-staking-management/components/ValidatorSummary.tsx:68:14" data-component-path="src/app/validator-staking-management/components/ValidatorSummary.tsx" data-component-line="68" data-component-end-line="68" data-component-file="ValidatorSummary.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-2xs%20text-muted-foreground%2F60%20mt-0.5%22%7D" className="text-2xs text-muted-foreground/60 mt-0.5">{card.source}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
